export default __webpack_public_path__ + "static/media/photohow.eb3d17b8.svg";